// eslint-disable-next-line no-restricted-imports
import { ClientVersionFragment } from 'api/generated/graphql';
import {
  ClientVersionEntity,
  ClientVersionUpdatedEntityType,
} from 'api/types/entity';
import { parseFullName } from 'helpers';

export const parseClientVersionEntity = (
  data: ClientVersionFragment | undefined | null
): ClientVersionEntity | undefined =>
  data
    ? {
        clientId: data.clientId,
        clientSnapshotId: data.clientSnapshotId,
        clientRepresentativeSnapshotId:
          data.clientRepresentativeSnapshotId ?? undefined,
        createdAt: new Date(data.createdAt),
        createdBy: data.createdBy
          ? {
              id: data.createdBy.id,
              name: parseFullName(data.createdBy),
            }
          : null,
        id: data.id,
        number: data.number,
        reason: data.reason,
        updatedEntity: {
          fullName: data.updatedEntity.fullName,
          id: data.updatedEntity.id,
          type: ClientVersionUpdatedEntityType[data.updatedEntity.type],
        },
      }
    : undefined;
